module.exports = __webpack_public_path__ + "img/authGuide.9b4c38e4.png";